import { render, staticRenderFns } from "./credential.vue?vue&type=template&id=958e80a2&"
import script from "./credential.vue?vue&type=script&lang=js&"
export * from "./credential.vue?vue&type=script&lang=js&"
import style0 from "./credential.vue?vue&type=style&index=0&id=958e80a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports